import { render } from "./Dashboard-Kaunter.vue?vue&type=template&id=13b0afd0"
import script from "./Dashboard-Kaunter.vue?vue&type=script&lang=js"
export * from "./Dashboard-Kaunter.vue?vue&type=script&lang=js"

import "./Dashboard-Kaunter.vue?vue&type=style&index=0&id=13b0afd0&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__